// id="file"のタグを取得
const fileInput = document.getElementById("FilePicker");

// FileReaderインスタンスを作成
const reader = new FileReader();

// 初期値を定義
let onlyProductVariants = [];
let addToCartCsvProducts = [];
let errorProducts = []; //エラーが出た商品
let uniqueErrorProducts;
let rowNumber = 1;

// クラス名用に品番をサニタイズ
const sanitizeHandleClass = (handle) =>
  (handle || "").replace(/[^A-Za-z0-9_-]/g, "");

// CSVをパース（ダブルクオートや改行を考慮）
const parseCsv = (text) => {
  const rows = [];
  let row = [];
  let current = "";
  let insideQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (char === '"') {
      if (insideQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        insideQuotes = !insideQuotes;
      }
    } else if ((char === "\n" || char === "\r") && !insideQuotes) {
      if (current !== "" || row.length > 0) {
        row.push(current);
        rows.push(row);
        row = [];
        current = "";
      }
    } else if (char === "," && !insideQuotes) {
      row.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  if (current !== "" || row.length > 0) {
    row.push(current);
    rows.push(row);
  }

  return rows;
};

// プロパティーの初期値
let cartItemPropertiesArr = [];

// ファイルが選択されたときにはしる関数
fileInput.onchange = () => {
  let result = fileInput.files[0];
  reader.readAsText(result);
  rowNumber = 1;
  errorProducts = [];
};

// カート内のプロパティーを取得
document.querySelectorAll("input.cartProperty").forEach(function (value) {
  // console.log(value.name)
  // console.log(value.value)
  cartItemPropertiesArr.push([value.name, value.value]);
});

// カート内のプロパティーをオブジェクトに変更
const cartItemPropertiesObj = Object.assign(
  ...cartItemPropertiesArr.map(([key, value]) => ({ [key]: value }))
);
// console.log(cartItemPropertiesObj)

// ファイルが読み込まれたときにはしる関数
reader.onload = () => {
  // 見た目を初期化
  document.getElementById("sdtAddToCartButton").disabled = true;
  document.getElementById("outPutError").innerHTML = "";
  addToCartCsvProducts = [];
  errorProducts = [];
  onlyProductVariants = [];

  const normalizedText = (reader.result || "")
    .replace(/^\ufeff/, "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/\t/g, ",");

  const rows = parseCsv(normalizedText);
  const headerIndex = rows.findIndex((row) => {
    const trimmed = row.map((cell) => cell.trim());
    return trimmed.includes("品番") && trimmed.includes("個数");
  });

  if (headerIndex === -1) {
    document.getElementById("outPutCsv").innerHTML = "";
    document.getElementById(
      "outPutError"
    ).innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">選択されたCSVの形式は、システムデザインツールの形式と異なっております。<br>CSVをご確認の上、再度CSVを選択してください。</p>`;
    return;
  }

  const items = rows[headerIndex].map((cell) => cell.trim());
  const dataRows = rows
    .slice(headerIndex + 1)
    .filter(
      (row) =>
        row.some((cell) => cell.trim() !== "") &&
        !(row[0] || "").trim().startsWith("＊")
    );

  const jsonArray = dataRows.map((row) => {
    const line = {};
    for (let j = 0; j < items.length; j++) {
      line[items[j]] = (row[j] || "").trim();
    }
    return line;
  });

  const invalidQuantityRows = jsonArray.filter((line) => {
    const hasPartNumber = (line["品番"] || "").trim() !== "";
    if (!hasPartNumber) return false;
    return line["個数"] === "" || isNaN(Number(line["個数"]));
  });

  const keys = items.slice(0, 5);

  const rs = `<table style="width:100%; table-layout:auto; text-align:center;">
              <thead>
                <tr>
                  ${keys
                    .map(
                      (key) =>
                        `<th style="width:auto; background-color:#6464E6; color:white; padding:10px 20px;">${key}</th>`
                    )
                    .join("\n")}
                </tr>
              </thead>
              <tbody>
                ${jsonArray
                  .map((it) => {
                    const handleSanitized = sanitizeHandleClass(
                      (it["品番"] || "").replace(/"/g, "")
                    );
                    const invalidQuantity =
                      (it["個数"] || "") === "" || isNaN(Number(it["個数"]));
                    const rowClass = [
                      handleSanitized ? `row-${handleSanitized}` : "",
                      invalidQuantity ? "invalidQuantityRow" : "",
                    ]
                      .filter(Boolean)
                      .join(" ");
                    const rowStyle = invalidQuantity
                      ? ' style="background-color:rgba(255,0,0,0.1); color:gray;"'
                      : "";
                    return `<tr class="${rowClass}"${rowStyle}>${keys
                      .map((key) => {
                        const value = it[key] || "";
                        const partNumberClass =
                          key === "品番" && value !== ""
                            ? sanitizeHandleClass(value.replace(/"/g, ""))
                            : key === "品番" && value === ""
                            ? "emptyPartNumber"
                            : "";
                        const invalidQuantityClass =
                          key === "個数" &&
                          (value === "" || isNaN(Number(value)))
                            ? "invalidQuantity"
                            : "";
                        const classNames = [
                          partNumberClass,
                          invalidQuantityClass,
                        ]
                          .filter(Boolean)
                          .join(" ");
                        return `<td class="${classNames}" style="padding:10px 20px;">${value}</td>`;
                      })
                      .join("\n")}</tr>`;
                  })
                  .join("")}
              </tbody>
            </table>
          `;

  document.getElementById("outPutCsv").innerHTML = rs;

  if (invalidQuantityRows.length) {
    document.getElementById(
      "outPutError"
    ).innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">最終列（個数）に数値が入力されていない行があります。<br>CSVをご確認の上、再度CSVを選択してください。</p>`;
    return;
  }

  const products = jsonArray
    .map((line) => ({
      handle: (line["品番"] || "").replace(/"/g, "").trim(),
      quantity: Number(line["個数"]),
    }))
    .filter((line) => line.handle !== "" && !isNaN(line.quantity));

  if (!products.length) {
    document.getElementById(
      "outPutError"
    ).innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">品番または個数の入力に不備があります。CSVをご確認ください。</p>`;
    return;
  }

  const addOrUpdateCartProduct = (variantId, quantity) => {
    const existing = addToCartCsvProducts.find((p) => p.id === variantId);
    if (existing) {
      existing.quantity += quantity;
      return;
    }
    addToCartCsvProducts.push({
      id: Number(variantId),
      quantity: Number(quantity),
      properties: cartItemPropertiesObj,
    });
  };

  const suffixes = ["", "J", "NJ"];
  let processedCount = 0;

  const handleNotFound = (handle) => {
    errorProducts.push(handle);
    uniqueErrorProducts = [...new Set(errorProducts)];
    document.getElementById(
      "outPutError"
    ).innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">以下の品番は見つかりませんでした。<br>対象外の商品(リスト内の赤背景商品)についてはカートに入りませんのでご注意ください。<br><span style="color:black; font-weight:bold;">${uniqueErrorProducts}</span></p>`;

    const sanitizedHandle = sanitizeHandleClass(handle);
    const rowClass = `row-${sanitizedHandle}`;

    var list = document.getElementsByClassName(rowClass);
    for (var i = 0; i < list.length; i++) {
      var element = list[i];
      element.classList.add("notExistProduct");
    }

    if (!list.length) {
      var cells = document.getElementsByClassName(`${sanitizedHandle}`);
      for (var i = 0; i < cells.length; i++) {
        cells[i].classList.add("notExistProduct");
      }
    }
  };

  const finishOne = () => {
    processedCount = processedCount + 1;
    if (processedCount === products.length) {
      document.getElementById("sdtAddToCartButton").disabled = false;
    }
  };

  products.forEach(({ handle, quantity }) => {
    if (!handle) {
      finishOne();
      return;
    }

    const tryFetch = (index) => {
      const targetHandle = `${handle}${suffixes[index]}`;
      jQuery
        .getJSON(`/products/${targetHandle}.js`, function (product) {
          const productVariants = product.variants || [];
          const matchedVariant =
            productVariants.find((variant) => variant.sku === handle) ||
            productVariants[0];

          if (matchedVariant) {
            addOrUpdateCartProduct(matchedVariant.id, quantity);
          } else {
            handleNotFound(handle);
          }
          finishOne();
        })
        .error(function () {
          if (index + 1 < suffixes.length) {
            tryFetch(index + 1);
          } else {
            handleNotFound(handle);
            finishOne();
          }
        });
    };

    tryFetch(0);
  });
};

// カートページへ遷移する関数
function goToCartPage() {
  document.location.href = "/cart";
}

// カートに追加ボタン
function addToCart() {
  // カートに追加するデータ
  // var formData = {
  //   items: [
  //     {
  //       "id": 41002104062113,
  //       "quantity": 2,
  //       "properties" : {
  //         "配送方法": "通常配送"
  //       }
  //     },
  //     {
  //       "id": 41002105733281,
  //       "quantity": 2,
  //       "properties" : {
  //         "配送方法": "通常配送"
  //       }
  //     }
  //   ],
  // }

  var formData = {
    items: addToCartCsvProducts,
  };

  fetch("/cart/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then(() => {
      goToCartPage();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
